"use client";
import Icon from "../../common/components/Icon";
import { useLocale, useTranslations } from "next-intl";
import Tooltip from "../../theme/components/Tooltip";

const ProductAvailabilityTooltip = ({ availability, earliestDeliveryDate }) => {
  const t = useTranslations();
  const locale = useLocale();
  const dateFormatter = new Intl.DateTimeFormat(`${locale}-CH`, {
    dateStyle: "short",
  });
  const earliestDelivery = earliestDeliveryDate
    ? t.rich("estimated_delivery_date", {
        date: (
          <span className="delivery-time" key={"delivery-time"}>
            {earliestDeliveryDate &&
              dateFormatter.format(new Date(earliestDeliveryDate))}
          </span>
        ) as any,
      })
    : "";

  switch (availability) {
    case "stock_unknown":
      return (
        <Tooltip
          title={t("stock_unknown_small")}
          description={earliestDelivery}
        >
          <Icon icon="info" fill="currentColor" />
        </Tooltip>
      );
    case "in_stock":
      return (
        <Tooltip
          title={t("in_stock_small_tooltip")}
          description={earliestDelivery}
        >
          <Icon icon="shipment-ok" aria-label="in stock" />
        </Tooltip>
      );
    case "out_of_stock":
      return (
        <Tooltip title={t("out_of_stock_small")} description={earliestDelivery}>
          <Icon icon="shipment-nok" aria-label="out-of-stock" />
        </Tooltip>
      );
    case "unknown_delivery":
      return (
        <Tooltip title={t("unknown_delivery")} description={earliestDelivery}>
          <Icon
            icon="shipment-not-possible"
            aria-label="unknown delivery date"
          />
        </Tooltip>
      );
    case "deleted_product":
      return (
        <Tooltip title={t("deleted_product")} description={earliestDelivery}>
          <Icon icon="block" aria-label="deleted product" />
        </Tooltip>
      );
    default:
      return null;
  }
};

const ProductAvailability = ({
  availability,
  earliestDeliveryDate,
  className = "",
}) => {
  if (!availability) return null;
  return (
    <div
      className={`d-flex align-items-center ${className || ""}`}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onTouchStart={(e) => {
        e.stopPropagation();
      }}
    >
      <ProductAvailabilityTooltip
        availability={availability}
        earliestDeliveryDate={earliestDeliveryDate}
      />
    </div>
  );
};

export default ProductAvailability;
